<div class="dynamic-input-options">
  <h3>{{ dynamicInputName }}</h3>
  <app-cm-input
    [cmInput]="dynamicCMInputOptions.parent_input"
    [isInputOptionsParentInput]="true"
    (inputValueChangedNotifier)="onParentInputChange($event)"
    (layerInputValueChangedNotifier)="onParentLayerInputChange($event)"
  ></app-cm-input>

  @for (
    input of dynamicCMInputOptions[dynamicCMInputOptions.parent_input.input_value];
    track input.input_parameter_name
  ) {
    @if (calculationModuleService.isDynamicCMInputArray(input)) {
      <app-dynamic-cm-inputs-array [dynamicCMInputArray]="input"></app-dynamic-cm-inputs-array>
    } @else if (calculationModuleService.isDynamicCMInputOptions(input)) {
      <app-dynamic-cm-inputs-options
        [dynamicCMInputOptions]="input"
      ></app-dynamic-cm-inputs-options>
    } @else {
      <app-cm-input [cmInput]="input" [index]="$index"></app-cm-input>
    }
  }
</div>
